/**
 * import topicsDir from "../__topicsDir";
*/

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2024-01-22T11:00",
		title: `
		<h4>新潟県医師会在宅医療推進センターより</h4>
		<p class="paragraph-indent">
		●新潟県福祉保健部高齢福祉保健課との共同企画で、新潟県在宅医療・介護連携推進事業担当者研修会を1月19日（金）に開催いたしました。<br>
		講師は、公立大学法人埼玉県立大学大学院　保健医療福祉学研究科教授　川越雅弘先生、市町村担当者と推進センターコーディネーターがグループワークを通じ、目的を意識した事業の進め方について学びを深めました。
		</p>
		<div class="imageBox-3">
		<ul><li><img src="../../../zaitaku/contents/topics/2024/01-001/img01.png" alt="新潟県在宅医療推進センターコーディネーター研修会"></li></ul>
		<ul><li><img src="../../../zaitaku/contents/topics/2024/01-001/img02.png" alt="新潟県在宅医療推進センターコーディネーター研修会"></li></ul>
		<ul><li><img src="../../../zaitaku/contents/topics/2024/01-001/img03.png" alt="新潟県在宅医療推進センターコーディネーター研修会"></li></ul>
		</div>
		`.trim().replace(/\t|\n/g, "")
	}
];
